import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import CustomProxyForm from "./CustomProxyForm";

export default function AddProxy({
  isOpen,
  setIsOpen,
  onAdded = null,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAdded?: (proxyId: string) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <CustomProxyForm onBack={() => setIsOpen(false)} onAdded={onAdded} />
      </Content>
    </Component>
  );
}
